import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RemarkLinkPipe } from 'src/app/layouts/right-aside/right-combine-popup/remark-link.pipe';
import { TransToDefaultCurrencyPipe } from 'src/app/orignal/shared/pipes/default-currency.pipe';
import { StripTrailingZerosPipe } from 'src/app/orignal/shared/pipes/strip-trailing-zeros.pipe';
import { ArrayFromLengthPipe } from './array-from-length.pipe';
import { AssetsLinkPipe } from './assets-link.pipe';
import { AvatarDefaultPipe } from './avatar-default.pipe';
import { BreakLinetPipe } from './break-line.pipe';
import { ComputedStylePipe } from './computed-style.pipe';
import { ConversionCurrencyPipe } from './conversion-currency.pipe';
import { CountryFilterPipe } from './cuontry-filter.pipe';
import { CurrencyIconPipe } from './currency-icon.pipe';
import { CurrencySymbolPipe } from './currency-symbol.pipe';
import { CurrencyValuePipe } from './currency-value.pipe';
import { DecimalDigitPipe } from './decimal-digit.pipe';
import { ElegantDisplayPipe } from './elegant-display.pipe';
import { FilterByFactorPipe } from './filter-by-factor.pipe';
import { FilterByKeyValuePipe } from './filter-by-key-value.pipe';
import { FilterByTextPipe } from './filter-by-text.pipe';
import { FirstLetterPipe } from './first-letter.pipe';
import { FriendlyTimePipe } from './friendly-time.pipe';
import { GetBreakpointPipe } from './get-breakpoint.pipe';
import { GetFileNamePipe } from './get-file-name.pipe';
import { HtmlPipe } from './help-center-content.pipe';
import { LinkClickAblePipe } from './link-click-able.pipe';
import { MomentDatePipe } from './moment-date.pipe';
import { PluckPipe } from './pluck.pipe';
import { PreferWebpPipe } from './prefer-webp.pipe';
import { ProviderCategoryNamePipe } from './provider-category-name.pipe';
import { ReplacePipe } from './replace.pipe';
import { RouterActivePipe } from './router-active.pipe';
import { SafePipe } from './safe-url.pipe';
import { SliceArrayPipe } from './slice-array.pipe';
import { SliceSymbolStr } from './slice-symbol-str.pipe';
import { SortByKeyPipe } from './sort-by-key.pipe';
import { TextHighlightPipe } from './text-highlight.pipe';
import { TextOverflowPipe } from './text-overflow.pipe';
import { TostringPipe } from './tostring.pipe';
import { TranslatePipe } from './translate.pipe';
import { UnshiftPipe } from './unshift.pipe';
import { UsdChangeToUsdtPipe } from './usd-change-to-usdt.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    FirstLetterPipe,
    CountryFilterPipe,
    FilterByTextPipe,
    FilterByFactorPipe,
    DecimalDigitPipe,
    TextOverflowPipe,
    FilterByKeyValuePipe,
    UnshiftPipe,
    SliceArrayPipe,
    SafePipe,
    CurrencyIconPipe,
    UsdChangeToUsdtPipe,
    CurrencyValuePipe,
    ElegantDisplayPipe,
    TranslatePipe,
    ReplacePipe,
    HtmlPipe,
    GetFileNamePipe,
    MomentDatePipe,
    SliceSymbolStr,
    AssetsLinkPipe,
    RouterActivePipe,
    ProviderCategoryNamePipe,
    AvatarDefaultPipe,
    TostringPipe,
    SortByKeyPipe,
    CurrencySymbolPipe,
    ComputedStylePipe,
    GetBreakpointPipe,
    ArrayFromLengthPipe,
    TextHighlightPipe,
    ConversionCurrencyPipe,
    BreakLinetPipe,
    PreferWebpPipe,
    TransToDefaultCurrencyPipe,
    FriendlyTimePipe,
    LinkClickAblePipe,
    PluckPipe,
    RemarkLinkPipe,
    StripTrailingZerosPipe,
  ],
  exports: [
    FirstLetterPipe,
    CountryFilterPipe,
    FilterByTextPipe,
    FilterByFactorPipe,
    DecimalDigitPipe,
    TextOverflowPipe,
    FilterByKeyValuePipe,
    UnshiftPipe,
    SliceArrayPipe,
    SafePipe,
    CurrencyIconPipe,
    UsdChangeToUsdtPipe,
    CurrencyValuePipe,
    ElegantDisplayPipe,
    TranslatePipe,
    ReplacePipe,
    HtmlPipe,
    GetFileNamePipe,
    MomentDatePipe,
    SliceSymbolStr,
    AssetsLinkPipe,
    RouterActivePipe,
    ProviderCategoryNamePipe,
    AvatarDefaultPipe,
    TostringPipe,
    SortByKeyPipe,
    CurrencySymbolPipe,
    ComputedStylePipe,
    GetBreakpointPipe,
    ArrayFromLengthPipe,
    TextHighlightPipe,
    ConversionCurrencyPipe,
    BreakLinetPipe,
    PreferWebpPipe,
    TransToDefaultCurrencyPipe,
    FriendlyTimePipe,
    LinkClickAblePipe,
    PluckPipe,
    RemarkLinkPipe,
    StripTrailingZerosPipe,
  ],
})
export class PipesModule {}
